import axios from "axios";

import { BuildingProperties, DeviceType, Offers } from "./onboardingTypes";

export const fetchCitiesList = async (token: string) => {
  return axios
    .get(`${process.env.REACT_APP_API_PATH}/contract-energy/cities`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(({ data }) => {
      return data;
    });
};

export const fetchCityOffers = async (
  token: string,
  city: string
): Promise<Offers> => {
  return axios
    .get(
      `${process.env.REACT_APP_API_PATH}/users/contract_energy/offers?city=${city}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(({ data }) => {
      return data.data;
    });
};

export const sendInvoiceFile = async (token: string, file) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/users/contract_energy/invoice`,
      {
        invoice: file,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then(({ data }) => {
      return data;
    });
};

export const sendOfferData = async (
  token: string,
  name: string,
  email: string,
  phone: string,
  cpf: string,
  address: string,
  idFile,
  invoice,
  offerName: string
) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/users/contract_energy/invoice`,
      {
        name,
        email,
        phone,
        cpf,
        address,
        profile_picture: idFile,
        invoice,
        offerName,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then(({ data }) => {
      return data;
    });
};

export const fetchContractLink = async (
  token: string,
  name: string,
  email: string,
  phone: string,
  cpf: string,
  address: string,
  city: string,
  state: string,
  profilePicture,
  offerId: string
) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/users/contract_energy/personal-data`,
      {
        name,
        email,
        phone,
        cpf,
        address,
        city,
        state,
        profile_picture: profilePicture,
        offerName: ".",
        offer_id: offerId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then(({ data }) => {
      return data;
    });
};

export const sendBuilding = async (
  token: string,
  propertyName,
  propertyType,
  city,
  monthlyEnergyCost,
  airConditionedRoomsCount,
  voltageLevel,
  hasGreenEnergyContract,
  discount,
  devices,
  invoiceEnergy,
  buildingAvatar,
  rootSpace
) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/users/contract_energy/property`,
      {
        propertyName,
        propertyType,
        city,
        monthlyEnergyCost,
        airConditionedRoomsCount,
        voltageLevel,
        hasGreenEnergyContract,
        discountPercentage: discount || "0",
        ...devices,
        invoiceEnergy,
        buildingImage: buildingAvatar,
        rootSpace,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((res) => {
      return res;
    });
};

export const createBuilding = async (
  token: string,
  rootSpace,
  formCreateValues: Partial<BuildingProperties>
) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/users/contract_energy/property`,
      {
        ...formCreateValues,
        rootSpace,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((res) => {
      return res;
    });
};

export const patchBuilding = async (
  token: string,
  id: string,
  updatedFields: Partial<BuildingProperties>
) => {
  return axios
    .patch(
      `${process.env.REACT_APP_API_PATH}/users/contract_energy/property?id=${id}`,
      {
        updatedFields,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((res) => {
      return res;
    });
};

export const updateBuilding = async (
  token,
  id,
  rootSpace,
  propertyName,
  propertyType,
  city,
  monthlyEnergyCost,
  airConditionedRoomsCount,
  voltageLevel,
  hasGreenEnergyContract,
  discountPercentage,
  airSplit,
  airWindow,
  airCassette,
  buildingImage
) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_PATH}/users/contract_energy/property?id=${id}`,
      {
        propertyName,
        propertyType,
        city,
        monthlyEnergyCost,
        airConditionedRoomsCount,
        voltageLevel,
        hasGreenEnergyContract,
        discountPercentage,
        airSplit,
        airWindow,
        airCassette,
        rootSpace,
        buildingImage,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((res) => {
      return res;
    });
};

export const deleteBuilding = async (token: string, id: string) => {
  return axios.delete(
    `${process.env.REACT_APP_API_PATH}/users/contract_energy/property?id=${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const fetchACTypes = async (token: string): Promise<DeviceType[]> => {
  return axios
    .get(
      `${process.env.REACT_APP_API_PATH}/users/contract_energy/air-conditioning-types`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(({ data }) => {
      return data;
    });
};

export const fetchACModels = async (
  token: string
): Promise<Record<"id" | "name", string>[]> => {
  return axios
    .get(`${process.env.REACT_APP_API_PATH}/automation/brands`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(({ data }) => {
      return data.data;
    });
};
